import { render, staticRenderFns } from "./TerritoryCard.vue?vue&type=template&id=66d53076&scoped=true"
import script from "./TerritoryCard.vue?vue&type=script&lang=js"
export * from "./TerritoryCard.vue?vue&type=script&lang=js"
import style0 from "./TerritoryCard.vue?vue&type=style&index=0&id=66d53076&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66d53076",
  null
  
)

export default component.exports